module.exports = __webpack_public_path__ + "static/media/amp.7eb9219c.png";